'use client'

import React from 'react'

import type { Language } from '@/shared/providers'

import { formatPublishingDate } from './format'
import styles from './view.module.css'

type PostPublishingDateProps = { publishTime: string | null; lang: Language }

export function PostPublishingDate({ publishTime, lang }: PostPublishingDateProps) {
    const [date, setDate] = React.useState({ localeDate: '', dateTime: '' })

    React.useEffect(
        function setTimeInLocalTimezone() {
            if (!publishTime) {
                return
            }

            setDate(formatPublishingDate(publishTime, lang))
        },
        [publishTime, lang]
    )

    return (
        <section className={styles.postPublishingDateSection}>
            <p className={styles.postPublishingDateParagraph}>
                <time className={styles.postFullMetaDate} dateTime={date.dateTime}>
                    {date.localeDate}
                </time>
            </p>
        </section>
    )
}
